// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"tW-z","hovered":"uW-z","hoverImage":"vW-z","mainImage":"wW-z","imageNoBackground":"xW-z","fullSizeImage":"yW-z"};